'use client';

/**
 * McpHealthCard — Plan Synthesis on the Insights rail.
 *
 * The cost-plan analog of ObeyaHealthCard/RfqHealthCard: a thin variant
 * of the shared <SynthesisCard /> bound to the `mcp_health` BFF
 * strategy. Uses `mcpId` (not generic `entityId`) — the same stable
 * anchor the cost-plan graph card uses, set only by the explorer's
 * McpRow click, so a node click inside the graph can't swap which plan
 * this card is synthesizing.
 *
 * @see klyde_edge/ui_config/handlers/synthesis.py — mcp_health
 *
 * @component_role: Card
 * @component_type: Insights Card
 * @domain: Copilot / Insights (Cost Plan)
 * @layer: presentation
 */

import { Sparkles } from 'lucide-react';
import { SynthesisCard } from '@/components/canvas/cards/obeya/synthesis-card';
import { useViewportSelection } from '@/lib/stores/viewport-selection';

export function McpHealthCard() {
  const { mcpId } = useViewportSelection();
  return (
    <SynthesisCard
      title="Plan Synthesis"
      strategy="mcp_health"
      pinStrategyName="mcp_health"
      entitySid={mcpId}
      entityParam="semantic_id"
      emptyLabel="Select a cost plan"
      Icon={Sparkles}
      iconColor="text-amber-400"
    />
  );
}
